<template>
  <div class="header">

    <div class="container33 theme-showcase" v-if="(topimg != '' && topimg != null)">
      <img :src="topimg" style="max-width: 100%; display:block; margin:0 auto;"
        :style="topimgWidth == 0 ? 'width:100%;' : ('width:' + topimgWidth + 'px;')" />
    </div>


    <div class="container11 theme-showcase" style="width: 100%;"
      :style="'max-width:100%; width:' + FormWidth + 'px; min-height: 400px'">

      <div v-if="catelist != null && catelist != undefined && catelist.length > 0"
        style="background-color: #cce6ff; text-align: center; padding: 20px 0; color: #38789b; font-weight: bold;">
        To proceed, please select the following options:
      </div>

      <!-- <div style="text-align: center; margin: 0 -15px; margin-bottom: 30px; ">
        <div style="color: #fff; display: inline-block; 
    width: 50%;" v-for="(item, index) in catelist" :key="index">
          <div
            style="margin: 30px 15px 0 15px; text-align: center; background-color: #23468c; padding: 40px 0; cursor: pointer; border-radius: 4px;"
            @click="toreg(item.id)">
            {{ item.name }}
          </div>

        </div>
      </div> -->


      <div style="text-align: center; margin: 30px -15px; " v-for="(item,index) in categroup" :key="index">
        <div style="font-size: 36px; text-decoration: underline; color:#347ab6;">{{ item.label }}</div>
        <div class="catebox" v-for="(sitem, sindex) in item.catelist" :key="sindex">
          <div v-if="sitem.html==null"
          class="catediv"
            @click="toreg(sitem.id,sitem.payment,sitem.disable)">
            <div>
            {{ sitem.name }}
          </div>
          </div>
          <div v-else class="catediv"
            @click="toreg(sitem.id,sitem.payment,sitem.disable)">
            <div v-html="sitem.html"></div>
          </div>
        </div>
      </div>

      

    </div>

    <div class="container33 theme-showcase" v-if="(btmimg != '' && btmimg != null)">
      <img :src="btmimg" style="max-width: 100%; display:block; margin:0 auto;"
        :style="BottomImgWidth == 0 ? 'width:100%;' : ('width:' + BottomImgWidth + 'px;')" />
    </div>

    
  <!-- <div id="card-element"></div> -->
  
  <!-- <el-button type="success" size="mini" round icon="el-icon-plus" @click="payment">Add</el-button> -->
  <!-- <el-button type="success" size="mini" round icon="el-icon-plus" @click="handleCheckout">Add2222</el-button> -->
  

  </div>
</template>
  
<script>
import axios from 'axios'
import { loadStripe } from '@stripe/stripe-js';

export default {
  name: 'homeheader',
  data: function () {
    return {
      topimg: "",
      topimgWidth: 0,
      BottomImgWidth: 0,
      fieldlist: '',
      vallist: [],
      fieldval: [],
      fieldval2: [],
      fieldvalArr: [],
      imgsUrl: [],
      btmimg: '',
      checkList: [],
      btnDis: false,
      endtxt: '',
      FinishTxt: '',
      FinishHtml: '',
      FormWidth: 0,
      FormMarginTop: 0,
      FormMarginBtm: 0,
      qrcodeurl: '',
      catelist: [],
      categroup: [],
      stripe: null,
      stripePublicKey: 'pk_test_51OlwZBG1y312NnZ4BxYiJvTKdYYRRN0SksDCVqM46KyF0lKjFty1wCbANvcxabG0Q0LNAYP275BY3BkNvYjAFlfO00jAXBnS5B'
    }
  },
  computed: {
  },
  created() {
    // 在组件创建时加载Stripe实例
    this.loadStripe();
  },
  methods: {
    async loadStripe() {
      // 加载Stripe实例
      this.stripe = await loadStripe(this.stripePublicKey);
    },

    async createPaymentIntent() {
    // 使用Stripe实例创建支付Intent
    //const response = await this.$axios.post('/create-payment-intent', { amount: 1000 }); // 示例中假设使用Axios发送POST请求
    const clientSecret =this.stripePublicKey; //response.data.client_secret;

    // 使用Stripe Elements创建支付表单
    const elements = this.stripe.elements();
    const cardElement = elements.create('card');

    // 添加支付表单到页面
    cardElement.mount('#card-element');

    // // 处理支付表单提交
    // const { paymentIntent, error } = await this.stripe.confirmCardPayment(clientSecret, {
    //   payment_method: {
    //     card: cardElement,
    //     // 可以添加其他支付方法信息
    //   }
    // });

    // if (error) {
    //   console.error(error);
    //   // 处理支付错误
    // } else {
    //   // 支付成功，处理支付Intent
    //   console.log(paymentIntent);
    // }
  },
  async payment(){
    const elements = this.stripe.elements();
    const clientSecret =this.stripePublicKey;
    const { paymentIntent, error } = await this.stripe.confirmCardPayment(clientSecret, {
    payment_method: {
      card: elements.getElement('card'),
      billing_details: {
        // 在这里添加您的账单信息
      }
    }
  });

  if (error) {
    console.error('支付失败:', error);
    // 处理支付失败的情况
  } else {
    console.log('支付成功:', paymentIntent);
    // 处理支付成功的情况
  }
  },

  async handleCheckout() {
    try {
      const { sessionId } = await this.createCheckoutSession(); // 通过服务器端创建结账会话
      const result = await this.stripe.redirectToCheckout({
        sessionId: 'cs_test_a16Ca8nEscUhCCGzELBbupjtXtipbXkbEVXWAnYgCl96Yn1bsg8obbUtMR'
      });
      if (result.error) {
        console.error('重定向到结账页面时出错:', result.error);
      }
    } catch (error) {
      console.error('处理支付时出错:', error);
    }
  },
  createCheckoutSession(){
    return "cs_test_a1DxMSRNFiDQQnqpYccvXnj5qjL3tODTIuR7OMDalSsx5E0abgIIxvAEci";
  },

    toreg(cid,payment,disable) {
      if(!disable){

        this.$alert('<div>It is necessary for SEMI to collect, process, and store your personal information in order to administer your registration request and provide you with content related to your registration. For more information on our privacy practices, please review:</div><div style="text-align:center;"><a target="_blank" href="https://www.semi.org/en/privacy-policy">SEMI Privacy Policy</a></div><div style="text-align:center;"><a target="_blank" href="https://www.semiconsea.org/sites/semiconsea.org/files/2023-07/Privacy-Policy-SEA2023.pdf">Personal Data Protection Act</a></div>',
        'Before submitting this form, you are required to agree to the policy below:',
        {
          dangerouslyUseHTMLString: true,
          showClose:false,
          showCancelButton:true,
          cancelButtonText:'Close',
          confirmButtonText:'Agree',
        }).then(() => {
          if(payment){
          this.$router.push("reg?id=" + this.id + "&cid=" + cid);
          }else{
          this.$router.push("reg?id=" + this.id + "&cid=" + cid);
          }
        }).catch(() => {
          
        });
      }else{
        // this.createPaymentIntent();
      }
      // 
    },
    loadEvent() {
      this.loading = true;
      var userJson = JSON.parse(localStorage.getItem('userJson'));
      axios.post('/api/event/getOne?finish=1&code=' + this.id + '&no=' + this.no,
        {
          code: this.id,
          finish: 1,
          no: this.no
        }
      )
        .then(this.loadDataSucc)
    },
    loadDataSucc(res) {
      this.loading = false;
      res = res.data
      console.log(res);
      if (res && res.Code == 200) {
        var item = res;
        console.log(item);
        this.eventId = item.id;
        this.eventname = item.eventName;
        this.address = item.address;
        this.eventstartdate = item.beginDT;
        this.eventenddate = item.endDt;
        this.endtxt = item.endTxt;

        this.topimg = item.topimgUrl;
        this.topimgWidth = item.TopImgWidth;
        this.BottomImgWidth = item.BottomImgWidth,
          this.FormWidth = item.FormWidth;
        this.FormMarginTop = item.FormMarginTop;
        this.FormMarginBtm = item.FormMarginBtm;
        this.btmimg = item.bottomImgUrl;
        this.catelist = item.catelist;
        this.categroup = item.cateGroup;
      } else {
        if (res && res.Code == 301) {
          localStorage.removeItem('userJson');
          this.$router.replace('/login');
        }
      }
    },


  },
  mounted() {
    const id = this.$route.query.id;
    const cate = this.$route.query.cate;
    const no = this.$route.query.no;
    this.id = id;
    this.cate = cate;
    this.no = no;
    this.loadEvent();
  }
}
</script>
<style lang="stylus" scoped>

.container33{
  margin:0 auto;
}
.container11{
  background:#fff;
  margin:auto;
  max-width:100%;
}
.catediv2{
  margin: 30px 15px 0 15px; text-align: center; background-color: #0f1d42; padding: 40px 0; cursor: pointer; border-radius: 4px;
}
.catediv{
  text-align: center; background-color: #0f1d42; cursor: pointer; border-radius: 4px; 
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px; margin: 30px 15px 0 15px; 
  padding:1px;
  font-size: 22px;
}
.catebox{
  color: #fff;  max-width: 80%; vertical-align: top; margin:auto;
}
  </style>
  


// WEBPACK FOOTER //
// src/pages/home/selectcate.vue